/* AuraGlow theme JS — native Shopify AJAX cart, drawer, mobile menu */
(function () {
  "use strict";

  function money(cents) {
    var amount = (cents / 100).toFixed(2);
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en", {
        style: "currency",
        currency: window.AG_CURRENCY || "ZAR"
      }).format(cents / 100);
    } catch (e) {
      return amount;
    }
  }

  function toast(message) {
    var el = document.querySelector(".ag-toast");
    if (!el) {
      el = document.createElement("div");
      el.className = "ag-toast";
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.add("is-visible");
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove("is-visible"); }, 2500);
  }

  /* Mobile menu */
  var menu = document.querySelector(".ag-mobile-menu");
  document.querySelectorAll("[data-ag-menu-open]").forEach(function (btn) {
    btn.addEventListener("click", function () { menu && menu.classList.add("is-open"); });
  });
  document.querySelectorAll("[data-ag-menu-close]").forEach(function (btn) {
    btn.addEventListener("click", function () { menu && menu.classList.remove("is-open"); });
  });

  /* Cart drawer */
  var drawer = document.querySelector(".ag-cart-drawer");
  var overlay = document.querySelector(".ag-cart-overlay");

  function openCart() {
    renderCart();
    drawer && drawer.classList.add("is-open");
    overlay && overlay.classList.add("is-open");
  }
  function closeCart() {
    drawer && drawer.classList.remove("is-open");
    overlay && overlay.classList.remove("is-open");
  }
  document.querySelectorAll("[data-ag-cart-open]").forEach(function (btn) {
    btn.addEventListener("click", openCart);
  });
  document.querySelectorAll("[data-ag-cart-close]").forEach(function (btn) {
    btn.addEventListener("click", closeCart);
  });

  function fetchCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); });
  }

  function updateCount(count) {
    document.querySelectorAll(".ag-cart-count").forEach(function (el) { el.textContent = count; });
  }

  function renderCart() {
    var itemsEl = document.querySelector(".ag-cart-drawer__items");
    var emptyEl = document.querySelector(".ag-cart-drawer__empty");
    var footEl = document.querySelector(".ag-cart-drawer__foot");
    if (!itemsEl) return;
    fetchCart().then(function (cart) {
      updateCount(cart.item_count);
      if (!cart.items.length) {
        itemsEl.style.display = "none";
        if (footEl) footEl.style.display = "none";
        if (emptyEl) emptyEl.style.display = "grid";
        return;
      }
      itemsEl.style.display = "grid";
      if (footEl) footEl.style.display = "grid";
      if (emptyEl) emptyEl.style.display = "none";
      itemsEl.innerHTML = cart.items.map(function (item) {
        var img = item.image
          ? '<img class="ag-cart-item__img" src="' + item.image + '&width=128" alt="">'
          : '<div class="ag-cart-item__img"></div>';
        return (
          '<div class="ag-cart-item" data-key="' + item.key + '">' +
            img +
            '<div class="ag-cart-item__info">' +
              '<p class="ag-cart-item__title">' + item.product_title + "</p>" +
              (item.variant_title && item.variant_title !== "Default Title"
                ? '<p class="ag-cart-item__variant">' + item.variant_title + "</p>" : "") +
              '<p class="ag-cart-item__price">' + money(item.final_line_price) + "</p>" +
            "</div>" +
            '<div class="ag-cart-item__side">' +
              '<button class="ag-link-btn" data-ag-remove="' + item.key + '">Remove</button>' +
              '<div class="ag-qty">' +
                '<button data-ag-dec="' + item.key + '" aria-label="Decrease">&minus;</button>' +
                "<span>" + item.quantity + "</span>" +
                '<button data-ag-inc="' + item.key + '" aria-label="Increase">+</button>' +
              "</div>" +
            "</div>" +
          "</div>"
        );
      }).join("");
      var totalEl = document.querySelector("[data-ag-total]");
      if (totalEl) totalEl.textContent = money(cart.total_price);
    });
  }

  function changeLine(key, quantity) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function () { renderCart(); });
  }

  document.addEventListener("click", function (e) {
    var inc = e.target.closest("[data-ag-inc]");
    var dec = e.target.closest("[data-ag-dec]");
    var rem = e.target.closest("[data-ag-remove]");
    if (inc || dec || rem) {
      var key = (inc || dec || rem).getAttribute(inc ? "data-ag-inc" : dec ? "data-ag-dec" : "data-ag-remove");
      fetchCart().then(function (cart) {
        var line = cart.items.find(function (i) { return i.key === key; });
        if (!line) return;
        var qty = rem ? 0 : inc ? line.quantity + 1 : line.quantity - 1;
        changeLine(key, Math.max(0, qty));
      });
    }
  });

  /* Add to cart (product cards + product page) */
  document.addEventListener("submit", function (e) {
    var form = e.target.closest("[data-ag-add-form]");
    if (!form) return;
    e.preventDefault();
    var data = new FormData(form);
    var variantId = data.get("id");
    var quantity = parseInt(data.get("quantity") || "1", 10);
    if (!variantId) return;
    var btn = form.querySelector("[type=submit]");
    if (btn) btn.disabled = true;
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: quantity }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error("add failed");
        return r.json();
      })
      .then(function () {
        toast("Added to your bag");
        openCart();
      })
      .catch(function () { toast("Could not add this item"); })
      .finally(function () { if (btn) btn.disabled = false; });
  });

  /* Variant picker on product page */
  var variantSelect = document.querySelector("[data-ag-variant-select]");
  if (variantSelect) {
    variantSelect.addEventListener("change", function () {
      var option = variantSelect.options[variantSelect.selectedIndex];
      var idInput = document.querySelector("[data-ag-variant-id]");
      var priceEl = document.querySelector("[data-ag-price]");
      var submitBtn = document.querySelector("[data-ag-submit]");
      if (idInput) idInput.value = option.value;
      if (priceEl && option.dataset.price) {
        priceEl.innerHTML = money(parseInt(option.dataset.price, 10)) +
          (option.dataset.compare && parseInt(option.dataset.compare, 10) > parseInt(option.dataset.price, 10)
            ? " <s>" + money(parseInt(option.dataset.compare, 10)) + "</s>" : "");
      }
      if (submitBtn) {
        var available = option.dataset.available === "true";
        submitBtn.disabled = !available;
        submitBtn.textContent = available ? submitBtn.dataset.labelAdd : submitBtn.dataset.labelSoldout;
      }
    });
  }

  /* Quantity steppers outside drawer (product page) */
  document.querySelectorAll("[data-ag-qty-input]").forEach(function (input) {
    var wrap = input.closest(".ag-qty");
    if (!wrap) return;
    wrap.querySelector("[data-ag-qty-dec]") && wrap.querySelector("[data-ag-qty-dec]").addEventListener("click", function () {
      input.value = Math.max(1, parseInt(input.value || "1", 10) - 1);
    });
    wrap.querySelector("[data-ag-qty-inc]") && wrap.querySelector("[data-ag-qty-inc]").addEventListener("click", function () {
      input.value = parseInt(input.value || "1", 10) + 1;
    });
  });

  /* Keep header count fresh on load */
  fetchCart().then(function (cart) { updateCount(cart.item_count); });
})();
